import React from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import Switches from '../../../../../components/fields/Switches/Switches';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import { infoFormatterIntl } from '../../../../../utils/formatters';
import FileView from '../../../../../components/fields/FileInput/FileView';

export default function ServiceMarkView(props) {
  const {
    fieldsValidation = {},
    procedure,
    applicantType,
    currentApplication = {},
  } = props;

  const applicant_new = currentApplication?.applicant_new || {};
  const registry_subject = currentApplication?.registry_subject || {};
  const files = currentApplication?.files || [];

  const {
    logo_files,
    commercial_name,
  } = applicant_new;

  const {
    logo_files: old_logo_files,
    commercial_name: old_commercial_name,
  } = registry_subject;

  const commercial_change_document = files.find(item => item.collection_name === 'commercial_change_document');

  const hasServiceMarkData = !!logo_files || logo_files === null;
  const hasCommercialNameData = !!commercial_name || commercial_name === null;

  const isValidProcedure = [PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure);
  const isValidApplicantType = [USER_TYPE.LEGAL, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType);

  if (!isValidProcedure || !isValidApplicantType) {
    return null;
  }

  return (
    <>
      <div className="f4 mt-3">Изменился знак обслуживания и/или коммерческое обозначение</div>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasServiceMarkData,
            }}
            label="Изменился знак обслуживания"
          />
        </Col>
      </Row>
      {hasServiceMarkData && (
        <>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'old.logo_files',
              old_logo_files,
              fieldsValidation,
              'applicant.logo_files',
            )}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'new.logo_files',
              logo_files,
              fieldsValidation,
              'applicant_new.logo_files',
            )}
          </Row>
        </>
      )}
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => {},
              value: hasCommercialNameData,
            }}
            label="Изменилось коммерческое обозначение"
          />
        </Col>
      </Row>

      {hasCommercialNameData && (
        <>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'old.commercial_name',
              old_commercial_name,
              fieldsValidation,
              'applicant.commercial_name',
            )}
          </Row>
          <Row className="row-cols-2">
            {infoFormatterIntl(
              'new.commercial_name',
              commercial_name,
              fieldsValidation,
              'applicant_new.commercial_name',
            )}
          </Row>
          <Row className="row-cols-1">
            {infoFormatterIntl(
              'media.commercial_change_document',
              commercial_change_document ? (
                <FileView
                  readOnly
                  withoutMime
                  withoutHr
                  files={[commercial_change_document]}
                />
              ) : null,
              fieldsValidation,
              '',
              6,
            )}
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
